"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTAcceptTradeTransaction = void 0;
const crypto_1 = require("@arkecosystem/crypto");
const utils_1 = require("@protokol/utils");
const bytebuffer_1 = __importDefault(require("bytebuffer"));
const enums_1 = require("../enums");
const { schemas } = crypto_1.Transactions;
class NFTAcceptTradeTransaction extends crypto_1.Transactions.Transaction {
    static getSchema() {
        return schemas.extend(schemas.transactionBaseSchema, {
            $id: "NFTAcceptTrade",
            required: ["typeGroup", "asset"],
            properties: {
                type: { transactionType: enums_1.NFTTransactionTypes.NFTAcceptTrade },
                typeGroup: { const: enums_1.NFTExchangeTransactionsTypeGroup },
                amount: { bignumber: { minimum: 0, maximum: 0 } },
                vendorField: { anyOf: [{ type: "null" }, { type: "string", format: "vendorField" }] },
                asset: {
                    type: "object",
                    required: ["nftAcceptTrade"],
                    properties: {
                        nftAcceptTrade: {
                            type: "object",
                            required: ["auctionId", "bidId"],
                            properties: {
                                auctionId: {
                                    $ref: "transactionId",
                                },
                                bidId: {
                                    $ref: "transactionId",
                                },
                            },
                        },
                    },
                },
            },
        });
    }
    serialize() {
        var _a;
        const { data } = this;
        utils_1.Asserts.assert.defined((_a = data.asset) === null || _a === void 0 ? void 0 : _a.nftAcceptTrade);
        const buffer = new bytebuffer_1.default(32 + 32, true);
        buffer.append(data.asset.nftAcceptTrade.auctionId, "hex");
        buffer.append(data.asset.nftAcceptTrade.bidId, "hex");
        return buffer;
    }
    deserialize(buf) {
        const { data } = this;
        const nftAcceptTrade = {
            auctionId: buf.readBytes(32).toString("hex"),
            bidId: buf.readBytes(32).toString("hex"),
        };
        data.asset = {
            nftAcceptTrade,
        };
    }
    hasVendorField() {
        return true;
    }
}
exports.NFTAcceptTradeTransaction = NFTAcceptTradeTransaction;
Object.defineProperty(NFTAcceptTradeTransaction, "typeGroup", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: enums_1.NFTExchangeTransactionsTypeGroup
});
Object.defineProperty(NFTAcceptTradeTransaction, "type", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: enums_1.NFTTransactionTypes.NFTAcceptTrade
});
Object.defineProperty(NFTAcceptTradeTransaction, "key", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "NFTAcceptTrade"
});
Object.defineProperty(NFTAcceptTradeTransaction, "version", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: enums_1.NFTExchangeTransactionVersion
});
Object.defineProperty(NFTAcceptTradeTransaction, "defaultStaticFee", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: crypto_1.Utils.BigNumber.make(enums_1.NFTStaticFees.NFTAcceptTrade)
});
//# sourceMappingURL=nft-accept-trade.js.map